import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import { logger } from '@/utils/logger'

import { ApiTaRe250 } from '~/endpoints/ApiTaRe250'

// State type
// 実力テストランキング取得（志望校判断）
interface TestRankingRecord {
  results: {
    subjectOrder: string
    subjectScore: string
    nickName: string
    schoolName: string
  }[]
}
const getEmptyTestRankingRecord = (): TestRankingRecord => ({
  results: [],
})

// 実力テストランキング取得（志望校判断）
interface ActionParamsTestRankingRecord {
  fiscalYear: number
  testMonth: number
  testCount?: number
  subjectCode: string
  grade: number
  courseId: string
}

@Module({
  stateFactory: true,
  namespaced: true,
  name: 'apis/DetermineSchoolRanking',
})
export default class AbilityTestRepSchoolJudgSubj extends VuexModule {
  // States
  private testRankingRecord_ = getEmptyTestRankingRecord()

  // Getters
  // 実力テストランキング取得（志望校判断）
  get testRankingRecord(): TestRankingRecord {
    return this.testRankingRecord_
  }

  // Mutations
  @Mutation
  updateTestRankingRecord(value: TestRankingRecord) {
    this.testRankingRecord_ = value
  }

  @Action
  clear() {
    this.context.commit('updateTestRankingRecord', getEmptyTestRankingRecord())
  }

  @Action
  async getTestRankingRecord(param: ActionParamsTestRankingRecord) {
    logger.trace('in: getTestRankingRecord')
    const api = new ApiTaRe250.Api()

    // API: ApiTaRe250
    const result = await api.get<TestRankingRecord | null>(
      {
        query: {
          fiscalYear: param.fiscalYear,
          testMonth: param.testMonth,
          testCount: param.testCount,
          subjectCode: param.subjectCode,
          grade: param.grade,
          courseId: param.courseId,
        },
      },
      // Success
      (data, _) => {
        return {
          results: data.results,
        }
      },
      // Error
      (data, status) => {
        logger.error(status, data)
        return null
      }
    )
    if (result === null) {
      return
    }
    this.context.commit('updateTestRankingRecord', result)
  }
}
